import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface DialogData {
  icon?: string;
  title?: string;
  message?: string;
  yesTitle?: string;
  noTitle?: string;
  input?: {
    placeholder?: string;
    minlength?: number;
    maxlength?: number;
    required?: boolean;
  };
}

@Component({
  selector: 'sd-dialog-confirm',
  templateUrl: 'dialog-confirm.component.html',
  styleUrls: [
    '../../assets/css/form.scss',
    './dialog-confirm.component.scss'
  ],
  encapsulation: ViewEncapsulation.None
})
export class DialogConfirmComponent {
  value: string;
  constructor(
    public dialogRef: MatDialogRef<DialogConfirmComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) { }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
